export class CompanyUserUpdateRefusalReasonDto {
  name?: boolean;
  email?: boolean;
  phone?: boolean;
  attachments?: boolean;
}
